import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import { UserSummary } from '../../interfaces/User/UserSummary';
import { getUsers } from '../../api/User';

interface UsersDropdownProps {
  label?: string;
  userEmails: string[];
  onChange: (newEmails: string[]) => void;
  disabled?: boolean;
}

export const UsersDropdown = (props: UsersDropdownProps) => {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<UserSummary[]>([]);

  useEffect(() => {
    setLoading(true);
    getUsers({
      pagination: { page: 0, pageSize: 1_000_000 },
      order: 'desc',
      orderBy: 'email',
    })
      .then((res) => setUsers(res.data))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Autocomplete
        multiple
        disableCloseOnSelect
        limitTags={2}
        size='small'
        disabled={props.disabled}
        fullWidth
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.label}
            variant='outlined'
            fullWidth
          />
        )}
        options={users}
        getOptionLabel={(user) => user.email}
        onChange={(_, selectedUsers) =>
          props.onChange(selectedUsers.map((user) => user.email))
        }
        value={users.filter((user) => props.userEmails.includes(user.email))}
      />
      {loading && <CircularProgress size={24} />}
    </Box>
  );
};
